module.exports = __webpack_public_path__ + "img/jenny.85d06ab5.webp";